class GlobalVariablesClass {
    public lang = "";
}

export const GlobalVariables = new GlobalVariablesClass();